import { useState } from "react";

export const usePaginate = (initialPageSize = 10) => {
      const [pagination, setPagination] = useState({
            pageIndex: 0,
            pageSize: initialPageSize,
      });
      const skip = pagination.pageIndex * pagination.pageSize;
      const take = pagination.pageSize;

      return { pagination, setPagination, skip, take };
};
